// LineManager.js

import Line from './Line';

class LineManager {
  static createNewLine() {
    // console.log("Creating new line");
    return new Line([]);
  }

  static setLineType(lineID, type, setLines) {
    setLines(prevLines => 
      prevLines.map(line => 
        line.id === lineID ? { ...line, type } : line
      )
    );
  }

  static setLineGroup(lineID, group, setLines) {
    setLines(prevLines => 
      prevLines.map(line => 
        line.id === lineID ? { ...line, group } : line
      )
    );
  }

  // multiplier scales the per-press step. Pass `event.shiftKey ? 10 : 1`
  // from the keydown handler so holding Shift moves in big jumps for fast
  // edits.
  static handleEditLine(key, lineID, lines, setLines, multiplier = 1) {
    const step = 2 * multiplier;
    const direction = {
      ArrowUp: { dx: 0, dy: -step },
      ArrowDown: { dx: 0, dy: step },
      ArrowLeft: { dx: -step, dy: 0 },
      ArrowRight: { dx: step, dy: 0 },
    };
    const line = lines.find(l => l.id === lineID);
    if (!line) {
      console.error(`Line with ID ${lineID} not found.`);
      return; // Exit if the line is not found
    }
    if (direction[key]) {
      setLines(prevLines => {
        return prevLines.map(l => {
          if (l.id === lineID) {
            l.move(direction[key].dx, direction[key].dy);
          }
          return l;
        });
      });
    }
  }

  static handleEditLinePoint(key, point, lines, setLines, setSelectedLinePoint, multiplier = 1) {
    const step = 2 * multiplier;
    const direction = {
      ArrowUp: { dx: 0, dy: -step },
      ArrowDown: { dx: 0, dy: step },
      ArrowLeft: { dx: -step, dy: 0 },
      ArrowRight: { dx: step, dy: 0 },
    };
    
    if (direction[key]) {
      setLines(prevLines => {
        return prevLines.map(line => {
          const pointIndex = line.points.findIndex(p => p[0] === point[0] && p[1] === point[1]);
          if (pointIndex !== -1) {
            const newLine = new Line([...line.points]);
            newLine.updatePoint(pointIndex, direction[key].dx, direction[key].dy);
            return newLine;
          }
          return line;
        });
      });
      setSelectedLinePoint(prevPoint => {
        if (prevPoint) {
          return [
            prevPoint[0] + direction[key].dx,
            prevPoint[1] + direction[key].dy
          ];
        }
        return prevPoint;
      });
    }
  }

  static isPointNearLine(point, line, threshold) {
    return line.isPointNear(point, threshold);
  }

  static findClosestLine(point, lines, threshold) {
    let closestLine = null;
    let minDistance = Infinity;

    lines.forEach(line => {
      const distance = line.distanceToPoint(point);
      if (distance < minDistance && distance <= threshold) {
        minDistance = distance;
        closestLine = line;
      }
    });

    return closestLine;
  }

  static findClosestLinePoint(point, lines, threshold) {
    let closestPoint = null;
    let closestLine = null;
    let minDistance = Infinity;

    lines.forEach(line => {
      line.points.forEach(linePoint => {
        const distance = Math.hypot(point[0] - linePoint[0], point[1] - linePoint[1]);
        if (distance < minDistance && distance <= threshold) {
          minDistance = distance;
          closestPoint = linePoint;
          closestLine = line;
        }
      });
    });

    return { point: closestPoint, line: closestLine };
  }
}

export default LineManager;